import Select, { components } from "react-select";
import React,{useEffect, useState} from "react";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { filterDomainsForComponent } from "../../utils";
import { Actions } from "../../Action/index";
import { useLocation } from "react-router-dom";
import { Home_PAGE_URL } from "../../Router/routerUrl";
import { CurationFilters } from "../../Constants";

const customStyles = {
    control: (base) => ({
      ...base,
      height: 29,
      minHeight: 29,
      marginBottom: 5,
      borderColor: "lightgray",
    }),
    dropdownIndicator: (styles) => ({
      ...styles,
      paddingTop: 0,
      paddingBottom: 0,
      color: "lightgray",
    }),
    clearIndicator: (styles) => ({
      ...styles,
      paddingTop: 0,
      paddingBottom: 0,
      color: "lightgray",
    }),
    option: (baseStyles, state) => ({
      ...baseStyles,
      backgroundColor: state.isFocused
        ? "var(--light_color_shade)"
        : state.isSelected?'var(--light_color_shade)':"none",
      color: state.isFocused ? "#fff" : state.isSelected?"#fff":"none",
    }),
  };

// const renderNestedOption = (props, label, nestedOptions) => {
//   const { innerProps, selectOption } = props;

//   return (
//     <div className="nested-optgroup">
//       <div
//         style={{
//           color: "grey",
//           paddingLeft: "10px"
//         }}
//       >
//         {label}
//       </div>
//       {nestedOptions.map((nestedOption, i) => {
//         if (nestedOption.options) {
//           return renderNestedOption(
//             props,
//             nestedOption.displayName,
//             nestedOption.options
//           );
//         }
//         const nestedInnerProps = {
//           ...innerProps,
//           onClick: () => selectOption(nestedOption)
//         };
//         return (
//           <components.Option {...props} key={i} innerProps={nestedInnerProps}>
//             {nestedOption.displayName}
//           </components.Option>
//         );
//       })}
//       <br/>
//     </div>
//   );
// };

const ValueContainer = ({ children, ...props }) => {
    let [values, input] = children;
    if (Array.isArray(values)) {
      const plural = values.length === 1 ? "" : "s";
      values = `${values.length} selected`;
    }
  
    return (
      <components.ValueContainer {...props}>
        {values}
        {input}
      </components.ValueContainer>
    );
  };
 const NestedSelect = () => {
    const dispatch = useDispatch();
    const {expertAnsweredFilter} = bindActionCreators(Actions,dispatch)
    const userData = useSelector((state) => state.user); 
    const expertAnsweredState = useSelector((state) => state.answeredQuestions); 
    const options = [
        {
          label: "Select Domains",
          options:filterDomainsForComponent(userData.expertTopics)
        },
        {
          label: "Needs Curation",
          options: CurationFilters
        },
        {
            id: 17,
            label: "Transferred",
            value:'transferred',
            description:'transfer'
          }
      ];
      // console.log("1",expertAnsweredState.expertAllFilters)
  return (
    <Select
  className={"multiselect1"}
    components={{
        ValueContainer
    }}
    isMulti={true}
    onChange={value => {
      // console.log("val",value)
        expertAnsweredFilter(value);
    }}
    value={expertAnsweredState.expertAllFilters}
    styles={customStyles}
    hideSelectedOptions={false}
    options={options}
    closeMenuOnSelect ={false}
    placeholder="Select Filters"
  />
  )
 };

 export default NestedSelect;
